import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FormLabel } from "@mui/material";
import { Select } from "components";

const ApplicationYearSelector = ({ applicationYears = [], year, onChange }) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    const yearsLatestFirst = [...applicationYears].sort((a, b) => b - a);
    return yearsLatestFirst.map((year) => ({
      value: year,
      label: year,
    }));
  }, [applicationYears]);

  const handleChange = useCallback(
    (e) => {
      onChange?.(e.target.value);
    },
    [onChange]
  );

  return (
    <>
      <FormLabel sx={{ textWrap: "nowrap" }}>
        {t("KydTable.ApplicationYear")}
      </FormLabel>
      <Select value={year} options={options} onChange={handleChange} />
    </>
  );
};

export default ApplicationYearSelector;
